{
  "app": {
    "name": "TK Vault",
    "skipToContent": "Vai al contenuto"
  },
  "nav": {
    "main": "Navigazione principale",
    "dashboard": "Dashboard",
    "tickets": "Ticket",
    "search": "Ricerca",
    "queues": "Code",
    "noQueues": "Le code compaiono qui dopo il primo import.",
    "collapse": "Comprimi la barra laterale",
    "expand": "Espandi la barra laterale",
    "openMenu": "Apri il menu",
    "closeMenu": "Chiudi il menu",
    "administration": "Amministrazione",
    "users": "Utenti",
    "roles": "Ruoli e permessi",
    "audit": "Registro attività",
    "imports": "Importazioni",
    "collapseQueue": "Chiudi {{name}}",
    "expandQueue": "Apri {{name}}"
  },
  "header": {
    "searchLabel": "Cerca nell'archivio",
    "searchPlaceholder": "Numero ticket, oggetto, cliente…",
    "searchPlaceholderShort": "Cerca…",
    "searchShortcut": "Premi / per cercare"
  },
  "theme": {
    "label": "Aspetto",
    "light": "Chiaro",
    "dark": "Scuro",
    "system": "Automatico"
  },
  "dashboard": {
    "title": "Dashboard",
    "status": {
      "title": "Stato del sistema",
      "version": "Versione",
      "database": "Database",
      "connected": "Connesso",
      "unreachable": "Non raggiungibile",
      "loading": "Verifica in corso…",
      "error": "Il server non risponde. Controlla che il backend sia avviato.",
      "lastImport": "Ultimo import",
      "noImport": "Nessun import eseguito",
      "importOutcome": {
        "succeeded": "Completato",
        "failed": "Non riuscito",
        "running": "In corso",
        "rolled_back": "Annullato"
      },
      "importNewTickets": "{{count, number}} ticket nuovi",
      "importNewTickets_one": "{{count, number}} ticket nuovo"
    },
    "favorites": "Preferiti",
    "favoritesEmpty": "Nessun preferito: aprendo un ticket, premi «Preferito» (o il tasto s).",
    "recent": "Visti di recente",
    "recentEmpty": "Qui compaiono gli ultimi ticket che hai aperto."
  },
  "archive": {
    "emptyTitle": "L'archivio è vuoto",
    "emptyBody": "I ticket compaiono qui dopo il primo import dei dati del sistema sorgente. L'import si avvia dal pannello di amministrazione o da riga di comando.",
    "title": "Archivio",
    "tickets": "Ticket",
    "articles": "Articoli",
    "queues": "Code",
    "period": "Periodo coperto",
    "periodRange": "da {{from}} a {{to}}",
    "noScopeTitle": "Nessuna coda visibile",
    "noScopeBody": "Il tuo account non ha code da consultare. Chiedi a un amministratore di aggiungere almeno una coda al tuo ruolo (Ruoli e permessi → il tuo ruolo → Code visibili).",
    "emptyScopeTitle": "Nessun ticket nelle tue code",
    "emptyScopeBody": "Nelle code che puoi consultare non ci sono ticket."
  },
  "notFound": {
    "title": "Pagina non trovata",
    "body": "L'indirizzo non corrisponde a nessuna pagina dell'archivio.",
    "back": "Torna alla dashboard"
  },
  "studio": {
    "craftedBy": "crafted with",
    "name": "0Effort"
  },
  "common": {
    "close": "Chiudi",
    "save": "Salva",
    "cancel": "Annulla",
    "create": "Crea",
    "edit": "Modifica",
    "delete": "Elimina",
    "copy": "Copia",
    "copied": "Copiato",
    "yes": "Sì",
    "no": "No",
    "none": "Nessuno",
    "loading": "Caricamento…",
    "previous": "Precedenti",
    "next": "Successivi",
    "saved": "Modifiche salvate",
    "errorGeneric": "Operazione non riuscita. Riprova."
  },
  "auth": {
    "loading": "Verifica dell'accesso…",
    "brandTagline": "Il nostro diario dei segreti digitale, archiviato con amore",
    "signInTitle": "Accedi all'archivio",
    "username": "Nome utente o email",
    "password": "Password",
    "signIn": "Accedi",
    "invalidCredentials": "Nome utente o password non corretti.",
    "locked": "Account bloccato dopo troppi tentativi. Riprova dopo le {{time}} o chiedi a un amministratore di sbloccarlo.",
    "lockedNow": "Account bloccato per troppi tentativi sbagliati.",
    "retryIn": "Riprova tra {{time}}",
    "lockOver": "Puoi riprovare ad accedere.",
    "rateLimited": "Troppi tentativi da questo dispositivo. Riprova tra qualche minuto.",
    "mfaTitle": "Verifica in due passaggi",
    "mfaBody": "Inserisci il codice a 6 cifre mostrato dall'app di autenticazione.",
    "code": "Codice",
    "verify": "Verifica",
    "invalidCode": "Codice non valido o scaduto.",
    "passwordChangeTitle": "Scegli una nuova password",
    "passwordChangeBody": "Per continuare imposta una password personale.",
    "currentPassword": "Password attuale",
    "newPassword": "Nuova password",
    "confirmPassword": "Ripeti la nuova password",
    "passwordsDiffer": "Le due password non coincidono.",
    "changePassword": "Cambia password",
    "passwordHint": "Almeno {{length}} caratteri, con lettere maiuscole, minuscole e numeri o simboli.",
    "policy": {
      "too_short": "La password è troppo corta.",
      "too_few_classes": "Usa lettere maiuscole, minuscole e numeri o simboli.",
      "contains_username": "La password non può contenere il nome utente.",
      "same_as_current": "La nuova password deve essere diversa da quella attuale."
    },
    "setupTitle": "Attiva la verifica in due passaggi",
    "setupBody": "Inquadra il codice QR con un'app di autenticazione (per esempio Google Authenticator, Microsoft Authenticator o Aegis), poi inserisci il codice generato.",
    "setupRequired": "Il tuo ruolo richiede un secondo fattore per accedere all'archivio.",
    "setupManual": "Non riesci a inquadrare il codice? Inserisci questa chiave nell'app:",
    "activate": "Attiva",
    "signOut": "Esci"
  },
  "user": {
    "menu": "Menu utente",
    "profile": "Profilo"
  },
  "profile": {
    "title": "Profilo",
    "account": "Account",
    "username": "Nome utente",
    "email": "Email",
    "roles": "Ruoli",
    "noRoles": "Nessun ruolo assegnato",
    "passwordChanged": "Password aggiornata.",
    "twoFactor": "Verifica in due passaggi",
    "twoFactorOn": "Attiva: all'accesso viene chiesto anche un codice dell'app di autenticazione.",
    "twoFactorOff": "Non attiva. Aggiungi un secondo fattore per proteggere l'accesso all'archivio.",
    "enable2fa": "Attiva la verifica in due passaggi",
    "disable2fa": "Disattiva",
    "disable2faTitle": "Disattiva la verifica in due passaggi",
    "disable2faBody": "Conferma con la password e un codice dell'app.",
    "enabled2fa": "Verifica in due passaggi attivata.",
    "disabled2fa": "Verifica in due passaggi disattivata.",
    "requiredByRole": "Il tuo ruolo richiede la verifica in due passaggi: non puoi disattivarla."
  },
  "admin": {
    "users": {
      "title": "Utenti",
      "new": "Nuovo utente",
      "user": "Utente",
      "email": "Email",
      "roles": "Ruoli",
      "status": "Stato",
      "twoFactor": "2FA",
      "lastLogin": "Ultimo accesso",
      "active": "Attivo",
      "inactive": "Disattivato",
      "locked": "Bloccato",
      "mustChange": "Deve cambiare password",
      "never": "Mai",
      "username": "Nome utente",
      "displayName": "Nome visualizzato",
      "usernameHint": "Lettere, numeri e . _ - @. Non si può cambiare dopo.",
      "editTitle": "Modifica utente",
      "createdTitle": "Utente creato",
      "temporaryPassword": "Password temporanea",
      "temporaryPasswordBody": "Comunicala all'utente: la vedi solo ora. Al primo accesso dovrà sceglierne una nuova.",
      "resetPassword": "Reimposta password",
      "reset2fa": "Azzera 2FA",
      "unlock": "Sblocca",
      "reset2faDone": "Verifica in due passaggi azzerata.",
      "unlockDone": "Account sbloccato.",
      "accountActive": "Account attivo",
      "permissionOverrides": "Eccezioni ai permessi",
      "overridesHint": "Concedi o revoca singoli permessi rispetto a quelli dei ruoli.",
      "inherit": "Come da ruoli",
      "grant": "Concedi",
      "revoke": "Revoca",
      "personalScope": "Code visibili in aggiunta ai ruoli",
      "personalScopeHint": "Facoltativo: regole valide solo per questo utente.",
      "empty": "Nessun utente.",
      "errors": {
        "username_taken": "Questo nome utente esiste già.",
        "email_taken": "Questa email è già usata da un altro utente.",
        "cannot_deactivate_self": "Non puoi disattivare il tuo account.",
        "last_admin": "Deve restare almeno un amministratore attivo.",
        "admin_protected": "Gli amministratori non possono modificare altri amministratori.",
        "admin_role_reserved": "Solo un amministratore può assegnare o togliere il ruolo Amministratori.",
        "cannot_change_own_access": "Non puoi cambiare i tuoi ruoli o permessi: chiedilo a un amministratore.",
        "permission_escalation": "Non puoi dare permessi che tu stesso non hai.",
        "cannot_delete_self": "Non puoi eliminare il tuo account.",
        "cannot_view_self": "Stai già vedendo il pannello come te stesso.",
        "view_as_not_allowed": "Questo utente vede più di te: solo un amministratore può visualizzare il pannello come lui.",
        "user_inactive": "L'account è disattivato.",
        "view_as_read_only": "Durante «visualizza come» le modifiche sono disattivate."
      },
      "delete": "Elimina utente",
      "deleteNow": "Elimina definitivamente",
      "deleteConfirm": "Eliminare {{name}} ({{username}})? L'account viene cancellato con le sue sessioni, ruoli e permessi personali. Il registro attività conserva il suo nome. Non si può annullare.",
      "viewAs": "Visualizza come",
      "adminProtected": "È un amministratore: gli altri amministratori non possono modificarlo, eliminarlo, cambiargli password o verifica in due passaggi, né visualizzare il pannello come lui.",
      "adminRoleReserved": "Solo un amministratore può assegnare o togliere questo ruolo."
    },
    "roles": {
      "title": "Ruoli e permessi",
      "new": "Nuovo ruolo",
      "list": "Ruoli",
      "matrix": "Confronta i permessi",
      "matrixHint": "Per lavorare su un ruolo usa «Modifica». Qui confronti i ruoli che scegli e, se serve, cambi i permessi di più ruoli insieme.",
      "showRole": "Ruolo da modificare",
      "name": "Nome",
      "description": "Descrizione",
      "require2fa": "Richiede la verifica in due passaggi",
      "users_one": "{{count}} utente",
      "users_other": "{{count}} utenti",
      "system": "Ruolo di sistema",
      "editTitle": "Modifica ruolo",
      "createTitle": "Nuovo ruolo",
      "scope": "Code visibili",
      "scopeHint": "Gli utenti del ruolo vedono i ticket che corrispondono ad almeno una regola.",
      "systemScope": "Il ruolo di sistema vede tutte le code e ha tutti i permessi.",
      "deleteConfirm": "Eliminare il ruolo «{{name}}»? Gli utenti perderanno i permessi che ne derivano.",
      "saveMatrix": "Salva permessi",
      "errors": {
        "name_taken": "Esiste già un ruolo con questo nome.",
        "system_role": "Il ruolo di sistema non si può eliminare.",
        "unknown_queue": "Una delle code selezionate non esiste più.",
        "system_role_locked": "Il ruolo Amministratori non si può modificare.",
        "permission_escalation": "Non puoi dare permessi che tu stesso non hai."
      },
      "systemLocked": "Il ruolo Amministratori è fisso: nome, descrizione, permessi e code non si modificano. Puoi solo richiedere la verifica in due passaggi a tutti gli amministratori.",
      "noQueues": "Nessuna coda",
      "noQueuesWarning": "Senza almeno una regola qui sotto, chi ha questo ruolo non vede nessun ticket. Aggiungi una regola (anche «Tutte le code»).",
      "compared": "Ruoli nel confronto",
      "permissions": "Permessi",
      "permissionsHint": "Cosa possono fare gli utenti con questo ruolo.",
      "systemPermissions": "Il ruolo Amministratori ha sempre tutti i permessi."
    },
    "scope": {
      "addRule": "Aggiungi regola",
      "removeRule": "Rimuovi regola",
      "queue": "Coda",
      "allQueues": "Tutte le code",
      "includeSubqueues": "Includi le sottocode",
      "customer": "Cliente (facoltativo)",
      "customerHint": "Codice cliente o indirizzo; * come jolly, per esempio ACME*",
      "from": "Dal",
      "to": "Al",
      "noRules": "Nessuna regola: nessun ticket visibile.",
      "rule": "Regola {{n}}",
      "retired": "dismessa"
    },
    "audit": {
      "title": "Registro attività",
      "when": "Data e ora",
      "user": "Utente",
      "action": "Azione",
      "target": "Oggetto",
      "ip": "Indirizzo IP",
      "details": "Dettagli",
      "filterAction": "Tipo di attività",
      "allActions": "Tutte",
      "filterFrom": "Dal",
      "filterTo": "Al",
      "empty": "Nessuna attività registrata con questi filtri.",
      "total_one": "{{count}} attività",
      "total_other": "{{count}} attività",
      "groups": {
        "auth": "Accessi",
        "ticket": "Consultazione ticket",
        "admin": "Amministrazione",
        "cli": "Riga di comando"
      }
    }
  },
  "permissions": {
    "groups": {
      "archive": "Archivio",
      "ticket": "Contenuto dei ticket",
      "attachment": "Allegati",
      "export": "Esportazione e stampa",
      "admin": "Amministrazione"
    },
    "archive.browse": "Consultare i ticket",
    "dashboard.view": "Vedere la dashboard",
    "search.fulltext": "Ricerca nel testo",
    "ticket.internal_notes": "Vedere le note interne",
    "ticket.history": "Vedere lo storico",
    "customer.contact": "Vedere i contatti dei clienti",
    "attachment.view": "Vedere gli allegati",
    "attachment.download": "Scaricare gli allegati",
    "export.pdf": "Esportare in PDF",
    "export.eml": "Esportare email (EML/MBOX)",
    "export.json": "Esportare in JSON",
    "export.csv": "Esportare liste in CSV",
    "export.xlsx": "Esportare liste in Excel",
    "export.zip": "Esportazioni massive (ZIP)",
    "print": "Stampare",
    "admin.users": "Gestire gli utenti",
    "admin.roles": "Gestire ruoli e permessi",
    "admin.import": "Importare dati",
    "admin.themes": "Gestire i temi",
    "admin.settings": "Modificare le impostazioni",
    "admin.audit": "Consultare il registro attività",
    "admin.users_delete": "Eliminare gli utenti",
    "admin.users_view_as": "Visualizzare il pannello come un altro utente"
  },
  "service": {
    "retry": "Riprova",
    "autoRetry": "Nuovo tentativo automatico ogni 10 secondi.",
    "banner": "Problema del servizio",
    "adminHint": "Per chi amministra il server",
    "database_unavailable": {
      "title": "Il database non è raggiungibile",
      "body": "L'archivio tornerà disponibile appena il database sarà di nuovo attivo.",
      "hint": "verifica che il servizio MariaDB sia avviato e raggiungibile all'indirizzo configurato (DB_HOST, DB_PORT nel file .env)."
    },
    "database_access_denied": {
      "title": "Il server non riesce ad accedere con le credenziali del database",
      "body": "Il database risponde ma rifiuta l'accesso dell'applicazione.",
      "hint": "controlla DB_USER e DB_PASSWORD nel file .env (si possono rigenerare con python -m app.cli db-init)."
    },
    "database_missing": {
      "title": "Il database dell'archivio non esiste",
      "body": "Il server del database è attivo, ma il database dell'archivio non è stato creato.",
      "hint": "esegui python -m app.cli db-init e poi python -m app.cli db-upgrade."
    },
    "schema_outdated": {
      "title": "Lo schema dell'archivio non è aggiornato",
      "body": "L'applicazione è più recente della struttura del database.",
      "hint": "esegui python -m app.cli db-upgrade e ricarica la pagina."
    },
    "server_unreachable": {
      "title": "Il server dell'archivio non risponde",
      "body": "La pagina non riesce a contattare l'applicazione.",
      "hint": "verifica che l'applicazione sia avviata (python -m app.cli serve) e che questo dispositivo sia sulla stessa rete."
    }
  },
  "imports": {
    "title": "Importazioni",
    "workerDown": "Il processo che esegue le importazioni non risponde: i lavori restano in coda. Riavvia il servizio dell'archivio (sul server: sudo systemctl restart ticket-vault).",
    "upload": {
      "title": "Carica un dump",
      "intro": "Scegli dal tuo computer il backup del sistema sorgente (.sql oppure .sql.gz). I file .sql vengono compressi nel browser prima dell'invio, così si trasferiscono molti meno dati. Se la connessione si interrompe, scegli di nuovo lo stesso file: il caricamento riprende da dove si era fermato.",
      "file": "File del dump",
      "willCompress": "verrà compresso durante l'invio",
      "asIs": "già compresso, inviato così com'è",
      "resumeFound": "Questo file era già stato caricato in parte ({{percent}}): il caricamento riprende da lì.",
      "start": "Carica",
      "resume": "Riprendi",
      "pause": "Pausa",
      "cancel": "Annulla caricamento",
      "discard": "Elimina",
      "progressLabel": "Avanzamento del caricamento",
      "progress": "{{sent}} di {{total}} ({{percent}})",
      "speed": "{{speed}}/s",
      "left": "circa {{time}} rimanenti",
      "compressed": "{{stored}} trasferiti dopo la compressione",
      "paused": "Caricamento in pausa. Premi Riprendi per continuare, anche più tardi.",
      "done": "Caricamento completato: {{file}} è pronto per l'importazione.",
      "unfinished": "Caricamenti interrotti",
      "unfinishedHint": "Per riprenderne uno, scegli di nuovo lo stesso file qui sopra.",
      "choose": "Scegli file",
      "noFile": "Nessun file scelto"
    },
    "files": {
      "title": "File pronti per l'importazione",
      "intro": "I dump caricati qui sopra, o copiati direttamente sul server, compaiono in questo elenco.",
      "serverFolder": "Cartella sul server:",
      "free": "{{free}} liberi",
      "name": "File",
      "size": "Dimensione",
      "modified": "Data",
      "actions": "Azioni",
      "inUse": "in uso",
      "import": "Importa…",
      "delete": "Elimina",
      "deleteTitle": "Eliminare il file?",
      "deleteBody": "{{file}} verrà cancellato dal server. L'archivio già importato non cambia.",
      "empty": "Nessun dump sul server."
    },
    "run": {
      "title": "Importa {{file}}",
      "intro": "L'importazione gira in background: puoi chiudere la pagina e seguirne l'avanzamento in Attività. I ticket già presenti e invariati vengono saltati.",
      "dryRun": "Prova senza salvare",
      "dryRunHint": "Analizza il dump e conta cosa cambierebbe, senza modificare l'archivio.",
      "attachments": "Importa il contenuto degli allegati",
      "attachmentsHint": "Occupa molto più spazio. Senza, degli allegati restano nome, tipo e dimensione.",
      "inlineImages": "Immagini dentro le email",
      "inlineImagesHint": "Le immagini mostrate nel testo delle email (loghi, screenshot incollati).",
      "start": "Avvia importazione",
      "startDry": "Avvia la prova",
      "repairText": "Ripara i testi danneggiati con le email originali (consigliato)",
      "repairTextHint": "Nel vecchio helpdesk alcune email hanno perso lettere accentate e simboli, che compaiono come ?. Il dump contiene anche l'email originale così come era arrivata: TK Vault la usa per ricostruire il testo corretto, solo per quei messaggi. Disattivalo solo se vuoi un import un po' più veloce, accettando i ? nei testi."
    },
    "jobs": {
      "title": "Attività",
      "job": "Attività",
      "state": "Stato",
      "outcome": "Risultato",
      "when": "Avviata",
      "took": "durata {{time}}",
      "details": "Dettagli",
      "detailTitle": "Attività #{{id}}",
      "cancel": "Annulla",
      "dryRun": "prova",
      "empty": "Nessuna attività finora.",
      "counts": "{{new}} ticket nuovi, {{updated}} aggiornati, {{unchanged}} invariati",
      "rolledBack": "{{removed}} ticket rimossi, {{restored}} riportati alla versione precedente",
      "interruptedHint": "L'attività si è fermata perché il servizio è stato riavviato o arrestato. Se era un'importazione, l'archivio può essere riportato a prima con «Annulla questo import».",
      "kinds": {
        "import": "Importazione",
        "rollback": "Annullamento"
      },
      "status": {
        "queued": "In coda",
        "running": "In corso",
        "succeeded": "Completata",
        "failed": "Non riuscita",
        "interrupted": "Interrotta",
        "cancelled": "Annullata"
      }
    },
    "stages": {
      "restore": "Lettura del dump",
      "lookups": "Code, stati e persone",
      "tickets": "Ticket",
      "index": "Indice di ricerca",
      "stats": "Statistiche",
      "cleanup": "Pulizia",
      "rollback": "Annullamento"
    },
    "batches": {
      "title": "Importazioni eseguite",
      "batch": "Importazione",
      "tickets": "Ticket",
      "empty": "Nessuna importazione eseguita.",
      "rollback": "Annulla questo import",
      "rollbackTitle": "Annullare l'importazione #{{id}}?",
      "rollbackBody": "L'archivio torna com'era prima: {{new}} ticket aggiunti verranno rimossi e {{updated}} ticket modificati torneranno alla versione precedente.",
      "status": {
        "running": "In corso",
        "succeeded": "Completata",
        "failed": "Non riuscita",
        "rolled_back": "Annullata"
      }
    },
    "errors": {
      "unsupported_file": "Scegli un dump .sql o .sql.gz.",
      "already_compressed": "Il file è già compresso.",
      "empty_file": "Il file è vuoto.",
      "insufficient_storage": "Spazio insufficiente sul server: servono {{needed}}, ne restano {{free}}.",
      "upload_closed": "Questo caricamento è stato chiuso o annullato. Scegli di nuovo il file per ricominciare.",
      "checksum_mismatch": "Un pezzo del file è arrivato danneggiato. Controlla la connessione e premi Riprendi.",
      "invalid_chunk": "Un pezzo del file non è valido. Ricomincia il caricamento.",
      "network": "Connessione al server persa. Il caricamento è fermo: premi Riprendi quando la rete torna.",
      "not_found": "Il file non esiste più sul server.",
      "file_in_use": "Il file è usato da un'attività in corso.",
      "job_active": "C'è già un'attività in coda o in corso: aspetta che finisca.",
      "not_cancellable": "L'attività è già partita e non si può più annullare.",
      "storage_full": "Spazio esaurito sul server (disco pieno o quota dell'utente raggiunta in Virtualmin). Libera spazio o aumenta la quota, poi premi Riprendi."
    }
  },
  "tickets": {
    "filters": {
      "text": "Numero o titolo",
      "textPlaceholder": "es. 2024031510000123 o stampante",
      "queue": "Coda",
      "allQueues": "Tutte le code",
      "state": "Stato",
      "allStates": "Tutti gli stati",
      "customer": "Cliente",
      "customerPlaceholder": "codice cliente o utente",
      "from": "Creati dal",
      "to": "Creati fino al",
      "sort": "Ordina per",
      "apply": "Filtra",
      "reset": "Azzera",
      "owner": "Assegnato a",
      "allOwners": "Tutti gli operatori"
    },
    "sorts": {
      "created_desc": "Più recenti",
      "created_asc": "Meno recenti",
      "changed_desc": "Ultima modifica",
      "number_desc": "Numero"
    },
    "columns": {
      "ticket": "Ticket",
      "queue": "Coda",
      "state": "Stato",
      "customer": "Cliente",
      "created": "Creato",
      "owner": "Assegnato a"
    },
    "untitled": "(senza titolo)",
    "messages_one": "{{count}} messaggio",
    "messages_other": "{{count}} messaggi",
    "emptyTitle": "Nessun ticket con questi filtri",
    "emptyBody": "Allarga i filtri o azzerali per vedere tutti i ticket che puoi consultare.",
    "range": "{{from}}–{{to}} di {{total}}",
    "none": "Nessun ticket",
    "saved": {
      "label": "Filtri salvati",
      "choose": "Scegli un filtro…",
      "none": "Nessun filtro salvato",
      "save": "Salva questi filtri",
      "delete": "Elimina filtro salvato",
      "dialogTitle": "Salva i filtri",
      "dialogBody": "Lo ritroverai in «Filtri salvati», anche da altri dispositivi.",
      "name": "Nome"
    }
  },
  "ticket": {
    "back": "Torna all'elenco",
    "backToSearch": "Torna alla ricerca",
    "notFoundTitle": "Ticket non trovato",
    "notFoundBody": "Il ticket {{number}} non esiste o non rientra nelle code che puoi consultare.",
    "details": "Dati del ticket",
    "state": "Stato",
    "queue": "Coda",
    "priority": "Priorità",
    "owner": "Assegnato a",
    "created": "Creato",
    "changed": "Ultima modifica",
    "closed": "Chiuso",
    "customer": "Cliente",
    "attachments": "Allegati",
    "unnamedFile": "file senza nome",
    "noDownloadPermission": "Non hai il permesso di scaricare gli allegati.",
    "contentNotImported": "Il contenuto di questo allegato non è stato importato.",
    "sender": {
      "customer": "Cliente",
      "agent": "Operatore",
      "system": "Sistema"
    },
    "internal": "Nota interna",
    "collapse": "Comprimi il messaggio",
    "expand": "Espandi il messaggio",
    "to": "A",
    "cc": "Cc",
    "lostChars": "Alcuni caratteri di questo messaggio erano già andati persi nel vecchio helpdesk (compaiono come ?).",
    "repaired": "Testo ricostruito dall'email originale: nel vecchio helpdesk era arrivato con caratteri persi.",
    "emptyBody": "(messaggio senza testo)",
    "thread_one": "Conversazione ({{count}} messaggio)",
    "thread_other": "Conversazione ({{count}} messaggi)",
    "collapseAll": "Comprimi tutti",
    "expandAll": "Espandi tutti",
    "history_one": "Storico ({{count}} evento)",
    "history_other": "Storico ({{count}} eventi)",
    "show": "Mostra",
    "hide": "Nascondi",
    "viewAs": "Mostra il messaggio come",
    "views": {
      "html": "Formattato",
      "text": "Solo testo"
    },
    "htmlFrame": "Messaggio formattato",
    "htmlError": "Non è stato possibile mostrare la versione formattata: usa «Solo testo».",
    "remoteBlocked_one": "1 immagine esterna non è stata caricata (servirebbe a chi ha inviato l'email per sapere che è stata aperta).",
    "remoteBlocked_other": "{{count}} immagini esterne non sono state caricate (servirebbero a chi ha inviato l'email per sapere che è stata aperta).",
    "inlineMissing_one": "1 immagine del messaggio non è nell'archivio.",
    "inlineMissing_other": "{{count}} immagini del messaggio non sono nell'archivio.",
    "previous": "Precedente",
    "next": "Successivo",
    "favorite": "Preferito",
    "unfavorite": "Togli dai preferiti",
    "copyLink": "Copia link",
    "linkCopied": "Link copiato"
  },
  "search": {
    "label": "Cerca nei ticket",
    "hint": "Cerca in oggetti, testi, indirizzi e numeri. \"frase esatta\", -parola per escludere, prefisso* per le parole che iniziano così. Un numero di ticket apre direttamente il ticket.",
    "submit": "Cerca",
    "subjectOnly": "Solo nell'oggetto",
    "intro": "Scrivi cosa cerchi: parole del testo, un indirizzo email, un cliente o un numero di ticket.",
    "noResults": "Nessun risultato per «{{q}}»",
    "noResultsBody": "Prova parole diverse o meno specifiche, oppure togli le date. Le parole di meno di 3 lettere non vengono cercate.",
    "results": "Risultati della ricerca",
    "matches_one": "{{count}} messaggio corrispondente",
    "matches_other": "{{count}} messaggi corrispondenti",
    "total_one": "{{formatted}} ticket trovato",
    "total_other": "{{formatted}} ticket trovati",
    "owner": "assegnato a {{name}}"
  },
  "viewAs": {
    "banner": "Stai vedendo TK Vault come {{name}} ({{username}}): permessi e code sono i suoi, le modifiche sono disattivate.",
    "stop": "Torna al tuo account",
    "profileDisabled": "Mentre visualizzi il pannello come un altro utente non puoi cambiare password o verifica in due passaggi."
  },
  "paging": {
    "perPage": "Per pagina",
    "all": "Tutti",
    "shown": "{{loaded}} di {{total}} mostrati",
    "loadMore": "Carica altri"
  },
  "shortcuts": {
    "title": "Scorciatoie da tastiera",
    "intro": "Funzionano quando non stai scrivendo in un campo.",
    "enter": "Invio",
    "search": "Cerca nell'archivio",
    "move": "Elenco e ricerca: riga successiva / precedente. Ticket: ticket successivo / precedente",
    "open": "Apre il ticket selezionato",
    "back": "Torna all'elenco",
    "favorite": "Aggiunge o toglie il ticket dai preferiti",
    "help": "Mostra questo aiuto",
    "close": "Chiude menu e finestre"
  }
}
